import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppServiceManager } from 'common/services/appServiceManager';
import { IBranch } from 'app/shared/Domains/branch';
import { MessageService, ConfirmationService, SelectItem } from "primeng/api";

@Component({
  selector: 'app-public-footer',
  templateUrl: './public-footer.component.html',
  styleUrls: ['./public-footer.component.css']
})
export class PublicFooterComponent {

  @Input() branch: string;
  branches : IBranch;
  selectedBranch: any;

  constructor(private route: ActivatedRoute,
    private appServiceManager: AppServiceManager,private messageService: MessageService,
    
    ) { }

  ngOnInit(): void {
    this.branches = new IBranch();
    this.getBranchById();
  }
  getBranchById() {
    this.appServiceManager.get('branches/'+ this.branch ).subscribe(
      (res) => {
        if (res) {
          this.selectedBranch = res;
        } else {
          this.branches = new IBranch();
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error) => {
        this.branches = new IBranch();
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }
  
}
